/* template */
<template><div class="cates-tab"><mpx-view v-for="(item, index) in (cates)" :key="item['{{ item.id }}']" :class="({        active: item.id === active      })" @tap="onClick(item.id)" class="tab-item">{{ item.name }}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m85698380"}'>
@import '../../../../lib/stylus/variable.styl'

.cates-tab
  position sticky
  top 0
  left 0
  width 700rpx
  height 83rpx
  padding 10rpx 25rpx
  // background-color #F0ECEC
  background-color #FFFDFD
  border-radius 20rpx 20rpx 0 0
  z-index 4
  display flex
  flex-flow row nowrap
  align-items center
  overflow-x scroll
  &::-webkit-scrollbar
    display none
.tab-item
  flex none
  font-size 28rpx
  color #666666
  padding 20rpx 25rpx
  &.active
    font-weight $fw-semi-bold
    font-size 32rpx
    color #000000
    position relative
    &:after
      content ''
      display block
      width 30rpx
      height 6rpx
      border-radius 3rpx
      background-color #F5621B
      box-shadow 0 0 4rpx 0 rgba(255, 178, 178, .5)
      position absolute
      bottom 10rpx
      left 50%
      margin-left -15rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  properties: {
    cates: {
      type: Array,
      required: true,
    },
    active: {
      type: [ Number, String ],
    },
  },
  methods: {
    onClick(id) {
      this.triggerEvent('change-cate', id)
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "tabs85698380",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
